export default {
  women: {
    id: 'women',
    category: 'Women',
    heading: 'Deals for her',
    linkUrl: 'shop/women',
  },
  men: {
    id: 'men',
    category: 'Men',
    heading: 'Deals for him',
    linkUrl: 'shop/men',
  },
  electrics: {
    id: 'electrics',
    category: 'Electrics',
    heading: 'Deals for the tech obsessed',
    linkUrl: 'shop/electrics',
  },
  kids: {
    id: 'kids',
    category: 'Kids',
    heading: 'Deals for kids',
    linkUrl: 'shop/kids',
  },
  home: {
    id: 'home',
    category: 'Home',
    heading: 'Furniture & Kitchen',
    linkUrl: 'shop/home',
  },
  other: {
    id: 'other',
    category: 'Other',
    heading: '',
    linkUrl: 'shop/other',
  },
};
